import { render, staticRenderFns } from "./PlanningServiceDetail.vue?vue&type=template&id=2a84aa8c&"
import script from "./PlanningServiceDetail.vue?vue&type=script&lang=js&"
export * from "./PlanningServiceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports